module.exports = "import { Colors } from 'hudl-rn-uniform-ui';\n"